import ms from 'ms'

export const AIDA_OVERLAY_OPEN_DURATION_MS = ms('460ms')
export const AIDA_FULLSCREEN_INSET_PX = 12

export interface OverlayFrame {
  top: number
  left: number
  width: number
  height: number
}

export function prefersReducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches
}

export function overlayFrameStyle(frame: OverlayFrame) {
  return {
    top: `${frame.top}px`,
    left: `${frame.left}px`,
    width: `${frame.width}px`,
    height: `${frame.height}px`,
  }
}

export function fullscreenRestingFrame() {
  return {
    top: AIDA_FULLSCREEN_INSET_PX,
    left: AIDA_FULLSCREEN_INSET_PX,
    width: window.innerWidth - AIDA_FULLSCREEN_INSET_PX * 2,
    height: window.innerHeight - AIDA_FULLSCREEN_INSET_PX * 2,
  }
}
